'use strict';

const addTimeDuration = (l, r) => {
  return {
    days: (l.days ?? 0) + (r.days ?? 0),
    hours: (l.hours ?? 0) + (r.hours ?? 0),
    minutes: (l.minutes ?? 0) + (r.minutes ?? 0),
    seconds: (l.seconds ?? 0) + (r.seconds ?? 0),
    milliseconds: (l.milliseconds ?? 0) + (r.milliseconds ?? 0)
  };
};

module.exports = addTimeDuration;
//# sourceMappingURL=addTimeDuration.cjs.map
